<template>
  <div>
    <div>
      <el-form ref="remakeForm" :model="remakeObj" label-width="80px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('product.productNo')"
              :prop="'productNo'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('product.productNo')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                v-if="Permit.extendModels().includes('wms')"
                size="small"
                v-model="remakeObj.productNo"
                filterable
                remote
                :loading="productsLoading"
                :remote-method="querySearchProductNo"
                @change="handleSelectProductNo"
              >
                <el-option
                  v-for="product in invProducts"
                  :key="product.productNo"
                  :label="product.productNo"
                  :value="product.productNo"
                />
              </el-select>
              <el-select
                v-else
                size="small"
                v-model="remakeObj.productNo"
                filterable
                remote
                :loading="productsLoading"
                :remote-method="querySearchProductNo"
                @change="handleSelectProductNo"
              >
                <el-option
                  v-for="product in products"
                  :key="product.productNo"
                  :label="product.productNo"
                  :value="product.productNo"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('product.color')" :prop="'color'">
              <el-select
                size="small"
                v-model="remakeObj.color"
                :placeholder="$t('product.color')"
                filterable
                clearable
                @change="getInvInfo"
              >
                <el-option
                  v-for="(color, idx) in productNoColors"
                  :key="idx"
                  :label="color"
                  :value="color"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('product.size')" :prop="'size'">
              <el-form-item>
                <el-select
                  size="small"
                  v-model="remakeObj.size"
                  :placeholder="$t('product.size')"
                  filterable
                  clearable
                  @change="getInvInfo"
                >
                  <el-option
                    v-for="(size, idx) in productNoSizes"
                    :key="idx"
                    :label="size"
                    :value="size"
                  />
                </el-select>
              </el-form-item>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="Permit.extendModels().includes('wms')">
            <el-row :gutter="30">
              <el-col :span="6">
                <el-form-item label-width="40px" :prop="'disableStockOut'">
                  <el-checkbox size="small" v-model="remakeObj.disableStockOut">
                    {{ $t("remake.disableStockOut") }}
                  </el-checkbox>
                </el-form-item>
              </el-col>
              <el-col v-if="!remakeObj.disableStockOut" :span="18">
                <el-form-item
                  :label="$t('menu.warehouses')"
                  :prop="'shopId'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('menu.warehouses')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    size="small"
                    v-model="remakeObj.shopId"
                    filterable
                    clearable
                    @change="getInvInfo"
                  >
                    <el-option
                      v-for="shop in shopsInv"
                      :key="shop.id"
                      :label="shop.name"
                      :value="shop.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('menu.suppliers')"
              :prop="'supplierId'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('menu.suppliers')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                size="small"
                v-model="remakeObj.supplierId"
                filterable
                clearable
              >
                <el-option
                  v-for="supplier in suppliers"
                  :key="supplier.id"
                  :label="supplier.text"
                  :value="supplier.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-row>
              <el-col :span="6">
                <el-form-item :label="$t('order.hurry')">
                  <el-checkbox size="small" v-model="remakeObj.hurry" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('purchase.replaceDeliver')">
                  <el-checkbox
                    size="small"
                    v-model="remakeObj.replaceDeliver"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :span="12"
                v-if="
                  Permit.extendModels().includes('wms') &&
                  !remakeObj.disableStockOut &&
                  remakeObj.shopId != null &&
                  remakeObj.productNo != null
                "
              >
                <el-form-item
                  :label="$t('inventory.invLockQty')"
                  :prop="'invQuantity'"
                >
                  <span class="grey font10"
                    >{{ invQuantity }}/{{ invTotalLock }}</span
                  >
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('remake.price')"
              :prop="'price'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('remake.price')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-input size="small" v-model.trim="remakeObj.price" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$t('text.handOverAt')"
              :prop="'handOverAt'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('text.handOverAt')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-date-picker
                size="small"
                v-model="remakeObj.handOverAt"
                type="date"
                style="width: 100%"
                :picker-options="pickerTodayAfterTime"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('text.remark')">
              <el-input size="small" v-model="remakeObj.remark" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="right pd20">
      <el-button
        size="small"
        type="primary"
        :loading="submitDoing"
        @click="submit"
      >
        {{ $t("text.submit") }}
      </el-button>
      <el-button size="small" type="default" @click="close">
        {{ $t("text.close") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import Util from "@/utils";
import { page } from "@/utils/mixins.js";

import Order from "@/api/order.js";
import Shop from "@/api/shop.js";
import Inventory from "@/api/inventory.js";
import Supplier from "@/api/supplier.js";
import Product from "@/api/product.js";

export default {
  props: {
    order: Object,
  },
  mixins: [page],
  components: {},
  data() {
    return {
      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      shops: [],
      shopsInv: [],
      suppliers: [],
      remakeObj: {
        serialNo: null,
        uuid: null,
        productNo: null,
        color: null,
        size: null,
        quantity: null,
        shopId: null,
        shopName: null,
        remark: null,
        disableStockOut: false,
        factoryId: null, //生产
        factoryName: null, //生产
        type: "purchase",
        supplierId: null, //外采
        supplierName: null, //外采
        supplierTenantId: null, //外采
        handOverAt: null, //外采
        hurry: null, //外采
        price: null, //外采
        replaceDeliver: false, //外采
      },
      productNoColors: [],
      productNoSizes: [],
      invQuantity: null,
      invTotalLock: null,
      invProducts: [],
      products: [],
      productsLoading: false,
      submitDoing: false,
    };
  },
  created() {
    const self = this;
    self.remakeObj.serialNo = self.order.serialNo;
    self.remakeObj.uuid = self.order.uuid;
    self.remakeObj.productNo = self.order.productNo;
    self.remakeObj.productNo = self.order.productNo;
    self.remakeObj.color = self.order.color;
    self.remakeObj.size = self.order.size;
    self.remakeObj.quantity = self.order.quantity;
    Shop.findByTenantId().then(function (res) {
      if (res.status === 200) {
        self.shops = res.data;
        self.shopsInv = res.data.filter((s) => s.isInventory === true);
      } else {
        self.sysError();
      }
      self.getProductNoColorSize();
      self.getSuppliers();
    });
  },

  methods: {
    getProductNoColorSize() {
      const self = this;
      self.productNoColors = [];
      self.productNoSizes = [];
      if (self.Permit.extendModels().includes("wms")) {
        Inventory.vagueFind({ productNo: self.remakeObj.productNo }).then(
          function (res) {
            if (res.status === 200) {
              if (res.data.length !== 0) {
                const inventoryInfo = res.data.find(
                  (i) => i.productNo == self.remakeObj.productNo
                );
                self.productNoColors = inventoryInfo.colors.filter(
                  (c) => c != null
                );
                self.productNoSizes = inventoryInfo.sizes.filter(
                  (c) => c != null
                );
              }
            } else {
              self.sysError();
            }
          }
        );
      } else {
        Product.findByProductNo({ productNo: self.remakeObj.productNo }).then(
          function (res) {
            if (res.data.code === 200) {
              const product = res.data.entity;
              self.productNoColors = product.colors;
              self.productNoSizes = product.sizes;
            } else {
              self.sysError();
            }
          }
        );
      }
    },

    getSuppliers() {
      const self = this;
      Supplier.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.suppliers = res.data;
          for (const supplier of self.suppliers) {
            Vue.set(supplier, "text", supplier.name);
          }
          self.getProductSuppliers();
        } else {
          self.sysError();
        }
      });
    },
    getProductSuppliers() {
      const self = this;
      Product.suppliersFindByProductNo({
        productNo: self.remakeObj.productNo,
      }).then(function (res) {
        if (res.status === 200) {
          const productSuppliers = res.data;
          if (productSuppliers.length !== 0) {
            for (const supplier of self.suppliers) {
              if (
                productSuppliers.find((ps) => ps.supplierId === supplier.id) !=
                null
              ) {
                supplier.text = supplier.name + "(产品供应商)";
              } else {
                supplier.text = supplier.name;
              }
            }
          }
        } else {
          self.sysError();
        }
      });
    },

    querySearchProductNo(queryString, cb) {
      const self = this;
      self.remakeObj.productNo = null;
      self.remakeObj.color = null;
      self.remakeObj.size = null;
      self.remakeObj.invInfoQuantity = null;
      self.remakeObj.invInfoTotalLock = null;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      this.productsLoading = true;
      if (self.Permit.extendModels().includes("wms")) {
        Inventory.vagueFind({ productNo: queryString }).then(function (res) {
          self.invProducts = res.data;
          self.productsLoading = false;
        });
      } else {
        Product.vagueFindByProductNo({ productNo: queryString }).then(function (
          res
        ) {
          self.products = res.data;
          self.productsLoading = false;
        });
      }
    },
    handleSelectProductNo() {
      const self = this;
      if (self.Permit.extendModels().includes("wms")) {
        const inventoryInfo = this.invProducts.find(
          (p) => p.productNo === self.remakeObj.productNo
        );
        self.productNoColors = inventoryInfo.colors.filter((c) => c != null);
        self.productNoSizes = inventoryInfo.sizes.filter((c) => c != null);
        self.getInvInfo();
      } else {
        const profuctInfo = self.products.find(
          (p) => p.productNo == self.remakeObj.productNo
        );
        self.productNoColors = profuctInfo.colors;
        self.productNoSizes = profuctInfo.sizes;
      }

      self.remakeObj.supplierId = null;
      self.remakeObj.supplierName = null;
      self.remakeObj.supplierTenantId = null;
      self.getProductSuppliers();
    },

    getInvInfo() {
      const self = this;
      self.invQuantity = null;
      self.invTotalLock = null;

      if (
        self.Permit.extendModels().includes("wms") &&
        self.remakeObj.shopId != null &&
        self.remakeObj.productNo != null
      ) {
        const obj = {
          shopId: self.remakeObj.shopId,
          productNo: self.remakeObj.productNo,
          color: self.remakeObj.color,
          size: self.remakeObj.size,
        };
        Inventory.findByProductInfo(obj).then(function (res) {
          if (res.data.code === 200) {
            const invInfo = res.data.entity;
            self.invQuantity = invInfo.quantity;
            self.invTotalLock = invInfo.totalLock;
          } else {
            self.invQuantity = "不存在";
            self.invTotalLock = "不存在";
          }
        });
      }
    },

    submit() {
      const self = this;
      this.$refs.remakeForm.validate((valid) => {
        if (valid) {
          if (!self.Permit.extendModels().includes("wms")) {
            self.remakeObj.disableStockOut = true;
          }
          if (self.remakeObj.disableStockOut === false) {
            if (
              self.Permit.extendModels().includes("wms") &&
              (self.invQuantity === "不存在" ||
                self.remakeObj.quantity > self.invQuantity - self.invTotalLock)
            ) {
              self.$message({
                message: self.$t("prompt.invQtyNotEnough"),
                type: "warning",
              });
              return;
            }
            self.remakeObj.shopName = self.shops.find(
              (s) => s.id === self.remakeObj.shopId
            ).name;
          }

          if (self.remakeObj.type === "purchase") {
            if (!Util.regexQuantity(self.remakeObj.price)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("purchase.price")]),
                type: "warning",
              });
              return;
            }
            self.remakeObj.supplierName = self.suppliers.find(
              (s) => s.id === self.remakeObj.supplierId
            ).name;
            self.remakeObj.supplierTenantId = self.suppliers.find(
              (s) => s.id === self.remakeObj.supplierId
            ).sourceTenantId;
            self.remakeObj.handOverAt = Util.formatDate(
              self.remakeObj.handOverAt
            );
          }
          self.submitDoing = true;
          Order.remake(self.remakeObj).then(function (res) {
            self.submitDoing = false;
            self.remakeDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.dealSuccess"),
                type: "success",
              });
              self.$emit("updateData");
              self.$eventHub.$emit("orderRemakePurchase");
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    close() {
      this.$emit("close");
    },
  },
};
</script>
